export function splitPriceByThree(price: number | string): string {
  const [integer, float] = String(price).split('.');
  let resultPrice = String(integer)
    .split('')
    .reverse()
    .join('')
    .match(/.{1,3}/g)!
    .join(' ')
    .split('')
    .reverse()
    .join('');
  if (float) {
    resultPrice = `${resultPrice}.${float}`;
  }
  return resultPrice;
}
